import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import FitquizPreview from '../components/fitquiz/FitquizPreview';
import FitQuizSettings from '../components/fitquiz/FitquizSettings';
import Loading from '../components/loading/Loading';
import { getButtonCss } from '../reducers/fit.quiz.button.reducer';
import { useAppDispatch, useAppSelector } from '../redux/redux.hooks';

type FitQuizProps = {};

const FitQuiz: FC<FitQuizProps> = () => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const { status, loadingMessage } = useAppSelector(
    (state) => state.fitButtonReducer
  );
  const { id } = params;

  useEffect(() => {
    dispatch(getButtonCss(id!));
  }, [dispatch, id]);

  const renderPage = () => {
    if (status === 'loading') {
      return <Loading loadingMessage={loadingMessage!} />;
    } else if (status === 'successful') {
      return (
        <Container>
          <SettingsContainer>
            <FitQuizSettings shop_id={id} />
          </SettingsContainer>
          <PreviewContainer>
            <FitquizPreview />
          </PreviewContainer>
        </Container>
      );
    }
  };

  return <>{renderPage()}</>;
};

export default FitQuiz;

const Container = styled.div`
  width: 90%;
  height: 100%;
  display: flex;
`;

const SettingsContainer = styled.div`
  width: 70%;
  padding: 10px 80px;
`;

const PreviewContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e4eaf0;
  width: 30%;
  height: 100%;
  min-height: 100vh;
`;
